module.exports = __webpack_public_path__ + "img/monthly-bonus.542d3738.png";